import api from './api'

export const DefaultApi = api(process.env.REACT_APP_PROFILE_BFF, {})
